// extracted by mini-css-extract-plugin
export var logo = "footer-module--logo--c7477";
export var mainFooter = "footer-module--main-footer--23626";